
define('text!editor/render/iframe.html',[],function () { return '<div id="preview-title">\r\n    <h2>\r\n        <span class="pull-left">Preview</span>\r\n        <button class="btn btn-primary pull-right" data-bind="click: close">Close</button>\r\n    </h2>\r\n</div>\r\n\r\n<iframe></iframe>\r\n';});

